import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Sparkles } from "lucide-react";
import Navbar from "../components/Navbar";
import { api } from "../lib/api";

export default function ItemDetail() {
  const { id } = useParams();
  const [item, setItem] = useState(null);

  useEffect(() => {
    api.get(`/catalog/${id}`).then(({ data }) => setItem(data)).catch(() => setItem(false));
  }, [id]);

  if (item === null) {
    return (
      <div className="relative z-10 min-h-screen">
        <Navbar />
        <p className="px-16 py-20 font-serif-display text-2xl italic text-[#8B5A2B]">Loading…</p>
      </div>
    );
  }

  if (!item) {
    return (
      <div className="relative z-10 min-h-screen">
        <Navbar />
        <div className="px-16 py-20">
          <p className="font-serif-display text-2xl">Piece not found.</p>
          <Link to="/catalog" className="text-[#6D214F] underline underline-offset-4 mt-4 inline-block">Back to collection</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="relative z-10 min-h-screen">
      <Navbar />
      <div className="px-6 md:px-16 py-10">
        <Link to="/catalog" data-testid="back-to-catalog" className="inline-flex items-center gap-2 text-sm text-[#4A4A4A] hover:text-[#6D214F] transition-colors mb-10">
          <ArrowLeft className="w-4 h-4" /> Back to the collection
        </Link>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <motion.div initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6 }} className="overflow-hidden rounded-sm bg-[#F4F1EA]">
            <img data-testid="detail-image" src={item.image} alt={item.title} className="w-full aspect-[3/4] object-cover" />
          </motion.div>

          <div className="lg:pt-8">
            <p className="text-xs uppercase tracking-[0.4em] text-[#8B5A2B] mb-4">{item.era} · {item.category}</p>
            <h1 className="font-serif-display text-4xl md:text-5xl leading-tight">{item.title}</h1>
            <p className="font-serif-display text-3xl mt-4">${item.price}</p>
            <div className="w-16 h-px bg-[#1A1A1A]/20 my-8" />
            <p className="text-base text-[#4A4A4A] leading-relaxed max-w-md">{item.description}</p>

            <Link
              to="/try-on"
              data-testid="try-on-button"
              className="group mt-10 inline-flex items-center gap-3 bg-[#1A1A1A] text-[#FDFBF7] px-8 py-4 rounded-sm hover:bg-[#6D214F] transition-colors duration-300"
            >
              <Sparkles className="w-4 h-4" />
              See it on me
            </Link>
            <p className="mt-4 text-xs text-[#4A4A4A]">A virtual fitting rendered from your own photo.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
